import * as Msal from 'msal'

export default class AuthService {
  constructor() {
    this.applicationConfig = {
      clientId: window._env_.VUE_APP_AZ_CLIENTID,
      apiScopes: [window._env_.VUE_APP_AZ_APISCOPES],
      redirectUri: window._env_.VUE_APP_AZ_REDIRECTURI,
      postLogoutRedirectUri: window._env_.VUE_APP_AZ_LOGOUTURI,
      authority: window._env_.VUE_APP_AZ_AUTHORITY
    }
    this.app = new Msal.UserAgentApplication({
      auth: {
        clientId: this.applicationConfig.clientId,
        authority: this.applicationConfig.authority,
        redirectUri: this.applicationConfig.redirectUri,
        postLogoutRedirectUri: this.applicationConfig.postLogoutRedirectUri,
        navigateToLoginRequestUrl: true
      }
    })
  }
  login = function() {
    const vm = this
    return this.app.loginRedirect(this.applicationConfig.apiScopes).then(
      idToken => {
        const user = vm.app.getAccount()
        // debugger
        if (user) {
          return user
        } else {
          return null
        }
      }
    ).catch(
      (error) => {
        // debugger
        console.error(error)
        return null
      })
  }
  logout = function() {
    this.app.logout()
  }
  getToken = function() {
    const vm = this
    return this.app.acquireTokenSilent({ scopes: this.applicationConfig.apiScopes }).then(
      accessToken => {
        return accessToken
      }
    ).catch(error => {
      // debugger
      console.error(error)
      return vm.app
        .acquireTokenPopup({ scopes: this.applicationConfig.apiScopes })
        .then(
          accessToken => {
            // debugger
            return accessToken
          }
        ).catch(
          (error2) => {
            // debugger
            console.error(error2)
            return null
          })
    })
  }
}
